import React from "react";
import { Layout, Typography, Space } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import { ApiTestButton } from "./ApiTestButton";

const { Title } = Typography;

export const Header: React.FC = () => {
  return (
    <Layout.Header
      style={{
        background: "#fff",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 24px",
        height: "64px",
        borderBottom: "1px solid #f0f0f0",
      }}
    >
      <Space>
        <FileTextOutlined style={{ fontSize: "24px", color: "#1890ff" }} />
        <Title level={4} style={{ margin: 0 }}>
          Rechnungsmanager
        </Title>
      </Space>
      
      <Space>
        <ApiTestButton />
      </Space>
    </Layout.Header>
  );
}; 